import React, { useState } from 'react';
import { Form, Button, Container, Row } from "react-bootstrap";
import { ToastContainer } from 'react-toastify';
import { useNavigate, useSearchParams } from "react-router-dom";
import { showToast } from '../reusables/CommonFunction';
import axiosInstance from '../../utils/axios';
import BusyLoaderOverlay from '../reusables/BusyLoaderOverlay';


export default function ForgotPasswordConfirmation() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const [resetPasswordState, setResetPasswordState] = useState({
        new_password: "",
        new_password_confirm: "", 
    });
    const [resetPasswordErrors, setResetPasswordErrors] = useState({
        new_password: "",
        new_password_confirm: "", 
    });
    const [responseState, setResponse] = useState({
        busyIndicator: false,
        message: ''
    });

    const onChange = (oEvent) => {
        setResetPasswordState({
            ...resetPasswordState,
            [oEvent.target.name]: oEvent.target.value,
        });
        if (!!resetPasswordErrors[oEvent.target.name])
            setResetPasswordErrors({
                ...resetPasswordErrors,
                [oEvent.target.name]: null,
            });
    };

    const onPressForgotPasswordConfirmation = (oEvent) => {
        oEvent.preventDefault();
        setIsSubmitting(true);
        let fErrorStatus = false;
    
        // Validation rules
        const passwordRules = [
            { regex: /.{8,}/, message: "Password length should be a minimum of 8 characters." },
            { regex: /(?=.*[A-Z])/, message: "Password must have at least one Uppercase character." },
            { regex: /(?=.*[a-z])/, message: "Password must have at least one Lowercase character." },
            { regex: /(?=.*[0-9])/, message: "Password must have at least one Digit." },
            { regex: /(?=.*[#?!@$%^&*-])/, message: "Password must have at least one Special Character." },
        ];
    
        // Validate new password
        if (!resetPasswordState.new_password.trim()) {
            fErrorStatus = true;
            setResetPasswordErrors((prevErrors) => ({
                ...prevErrors,
                new_password: "Password should not be empty.",
            }));
        } else {
            for (const rule of passwordRules) {
                if (!rule.regex.test(resetPasswordState.new_password)) {
                    fErrorStatus = true;
                    setResetPasswordErrors((prevErrors) => ({
                        ...prevErrors,
                        new_password: rule.message,
                    }));
                    break;
                }
            }
        }
    
        // Validate confirm password
        if (!resetPasswordState.new_password_confirm.trim()) {
            fErrorStatus = true;
            setResetPasswordErrors((prevErrors) => ({
                ...prevErrors,
                new_password_confirm: "Confirm Password should not be empty.",
            }));
        } else if (resetPasswordState.new_password_confirm !== resetPasswordState.new_password) {
            fErrorStatus = true;
            setResetPasswordErrors((prevErrors) => ({
                ...prevErrors,
                new_password_confirm: "Confirm Password does not match the new password.",
            }));
        }
    
        if (!fErrorStatus) {
            const oResetPasswordPayload = {
                uid: searchParams.get("uid"),
                token: searchParams.get("token"),
                type: searchParams.get("type"),
                new_password: resetPasswordState.new_password,
            };
    
            setLoading(true);
            setResponse((prevState) => ({ ...prevState, busyIndicator: true }));
            axiosInstance
                .post("/user/reset-password-confirmation/", oResetPasswordPayload, { skipAuth: true })
                .then((response) => {
                    setResetPasswordErrors({ new_password: "", new_password_confirm: "" });
                    setResetPasswordState({
                        new_password: "",
                        uid: "",
                        type: "",
                        token: "",
                    });
    
                    if (response.status === 202) {
                        showToast("success", response.data.message, {
                            onClose: () => navigate("/sign-in", { replace: true }),
                        });
                        setResponse((prevState) => ({ ...prevState, message: response.data.message }));
                    } else {
                        showToast("error", response.data.message);
                        setResponse((prevState) => ({ ...prevState, message: response.data.message }));
                    }
                })
                .finally(() => {
                    setIsSubmitting(false);
                    setLoading(false);
                });
        } else {
            setIsSubmitting(false);
        }
    };
    
    return (
        <>
            <Container className="ml-3 mr-3 mb-3">
                <Row>
                    <div className='col-md-12'>
                        <div className='content-section col-md-8'>
                            <legend className="border-bottom mb-4">Forgot Password</legend>
                            <Form autoComplete="off" noValidate>
                                <Form.Group className="mb-3" controlId="formNewPassword">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="new_password"
                                        value={resetPasswordState.new_password}
                                        onChange={onChange}
                                        isInvalid={resetPasswordErrors.new_password}
                                    />
                                    <Form.Text muted>Password must contain at least one uppercase.</Form.Text>
                                    <Form.Text muted>Password must contain at least one lowercase.</Form.Text>
                                    <Form.Text muted>Password must contain at least one digit.</Form.Text>
                                    <Form.Text muted>Password must contain at least one special character.</Form.Text>
                                    <Form.Text muted>Password should be of minimum 8 characters.</Form.Text>
                                    <Form.Control.Feedback type="invalid">{resetPasswordErrors.new_password}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formNewPasswordConfirm">
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="new_password_confirm"
                                        value={resetPasswordState.new_password_confirm}
                                        onChange={onChange}
                                        isInvalid={resetPasswordErrors.new_password_confirm}
                                    />
                                    <Form.Text muted>Enter the same password as before, for verification.</Form.Text>
                                    <Form.Control.Feedback type="invalid">{resetPasswordErrors.new_password_confirm}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formResetPasswordConfirmation">
                                    <Button type="submit" variant="primary" className="form-control" onClick={onPressForgotPasswordConfirmation}>
                                        { isSubmitting ? 'Submitting...' : 'Submit' }
                                    </Button>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Row>
                <ToastContainer />
                <BusyLoaderOverlay show={loading} />
            </Container>
        </>
    );
}